import * as React from 'react';
import { SuperAgentTooltip } from './SuperAgentTooltip';
import { SuperAgentBadge } from './SuperAgentBadge';

type TSuperAgentLevelViewProps = {
  levelName: string;
  tooltipText: string;
};

export const SuperAgentLevelView: React.FC<TSuperAgentLevelViewProps> = ({ levelName, tooltipText }) => {
  if (!tooltipText.length) {
    return <SuperAgentBadge levelName={levelName} />;
  }

  return (
    <SuperAgentTooltip tooltipText={tooltipText}>
      <SuperAgentBadge levelName={levelName} />
    </SuperAgentTooltip>
  );
};
